import { render } from "./DisclaimerBar.vue?vue&type=template&id=a730a0a2"
import script from "./DisclaimerBar.vue?vue&type=script&lang=js"
export * from "./DisclaimerBar.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__